import { Badge } from "@mui/material"

export function OutlinedBadge({ color, content, sx, ...props }) {
    return (
        <Badge
            sx={{
                ...(color && {
                    "& .MuiBadge-badge": {
                        color,
                        borderStyle: "solid",
                        borderWidth: "1px",
                    },
                }),
                ...sx,
            }}
            size="small"
            badgeContent={content}
            {...props}
        />
    )
}
